import React from 'react';

import './styles.css';

const Loading = () => (
  <div className="Loading">
    <div className="animation">
      <div className="dot" />
      <div className="dot" />
      <div className="dot" />
    </div>
  </div>
);

export default Loading;
